import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { string, func, array, bool } from 'prop-types';

import { AcademyLogoIcon } from '@snapask/common-components';
import { HOME } from '@snapask/common-components/dist/constants/routingPath';

import Link from '@blueberry/components/Link';

import { fetchRelatedPages, getRelatedPage } from '@blueberry/redux/header';
import { getLocaleCode } from '@blueberry/redux/locale';
import { generateAcademyURL } from '@blueberry/redux/navigation';

import PageList from './components/PageList';
import DragScroll from './components/DragScroll';
import AcademyLogoText from './images/logo-typography-academy.svg';

import styles from './PageListHeader.scss';

function PageListHeader({
  locale,
  fetchRelatedPages,
  pages,
  textLogo,
  getAcademyURL,
}) {
  useEffect(() => {
    fetchRelatedPages();
  }, [fetchRelatedPages, locale]);

  return (
    <div className={styles.root}>
      <Link className={styles.logo} to={getAcademyURL(HOME)}>
        {textLogo ? (
          <img src={AcademyLogoText} height={24} className={styles.icon} />
        ) : (
          <AcademyLogoIcon width={135} height={24} className={styles.icon} />
        )}
      </Link>
      <DragScroll>
        {scrollActions => <PageList pages={pages} {...scrollActions} />}
      </DragScroll>
    </div>
  );
}

PageListHeader.propTypes = {
  fetchRelatedPages: func.isRequired,
  getAcademyURL: func.isRequired,
  locale: string.isRequired,
  pages: array.isRequired,
  textLogo: bool.isRequired,
};

export default connect(
  state => ({
    pages: getRelatedPage(state),
    locale: getLocaleCode(state),
    getAcademyURL: generateAcademyURL(state),
  }),
  { fetchRelatedPages }
)(PageListHeader);



// WEBPACK FOOTER //
// ./app/components/PageListHeader/PageListHeader.jsx